// @ts-nocheck
import styled from 'styled-components';

export const ReportingAdvancedFilterResumePanelStyled = styled.div`
  .reportingAdvancedFilterResumePanel {

    &__boxContainer {
      margin-bottom: 40px;
    }

    &__header {
      display: flex;
      justify-content: space-between;
      align-items: self-end;
      margin-bottom: 8px;
    }

    &__text {
      color: ${props => props.theme.uiColors.boxBgCircleArrowRight};
      font-size: 14px;
    }

    &__buttonGroup {
      padding-bottom: 2px;
    }

    &__button {
      padding: 0 !important;
      height: 0;
    }

    &__box {
      margin-right: 0 !important;
      width: calc(25% - 12px) !important;
      flex-grow: 0;
      flex-shrink: 0;
    }

    &__firstRow {
      display: flex;
      flex-direction: row;
      width: 100%;
      gap: 16px;
      .reportingAdvancedFilterResumePanel__box {
        flex-grow: 1;
        flex-shrink: 1;
      }
    }

    &__secondRow {
      display: flex;
      flex-direction: row;
      margin-top: 8px;
      width: 100%;
      gap: 16px;
    }

    &__cartographyFilter {
      flex-grow: 1;
    }

    .reportingAdvancedFilterResumePanel__box {
      .middleSummaryBox__labelText {
        white-space: nowrap;
      }

      .middleSummaryBox__stringLabel {
        margin-left: 16px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }

`;
